window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

$.extend(true, theme.libs, {
  "navigation-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-navigation-custom.min.js?v=181604807025193770601741240631"
  },
  "navigation-vertical-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-navigation-vertical.min.js?v=33634404436856514401741240632"
  },
  "product-tabs-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-product-tabs.min.js?v=55648008384815742081741240636"
  },
  "instagram-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-instagram.min.js?v=119371711670684112801741240625"
  },
  "rich-banner-text-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-rich-banner-text.min.js?v=63409481287985558791741240639"
  },
  "layer-banner-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-layer-banner.min.js?v=17516369801962561231741240626"
  },
  "simple-product-slider-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-simple-product-slider.min.js?v=167477437608818092271741240641"
  },
  "product-columns-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-product-columns.min.js?v=44252666139423278881741240635"
  },
  "map-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-map.min.js?v=70999357964286274831741240629"
  },
  "quotes-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-quotes.min.js?v=144313337819941354051741240638"
  },
  "logo-bar-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-logo-bar.min.js?v=128265452728272567801741240627"
  },
  "shop-this-look-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-shop-this-look.min.js?v=26628376881593575481741240640"
  },
  "logo-us-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-logo-us.min.js?v=115732776597175329561741240628"
  },
  "more-explore-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-more-explore.min.js?v=97104527969463396131741240630"
  },
  "trending-products-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-trending-products.min.js?v=27516731244165870101741240643"
  },
  "single-deal-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-single-deal.min.js?v=25458204786684868451741240642"
  },
  "about-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-about.min.js?v=8502415123109276991741240621"
  },
  "newsletter-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-newsletter.min.js?v=141531588240217245561741240634"
  },
  "collection-filter-section": {
    "css": ["//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-collection-filter.scss.css?v=128999201589462829901741240812"],
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-collection-filter.min.js?v=132007993468101945291741240622"
  },
  "footer-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-footer.min.js?v=45245429994173559461741240624"
  },
  "product-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-section-product.min.js?v=7502656188594950601741240637"
  },
  "collection-template-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-collection.min.js?v=42238142061547863531741240611"
  },
  "search-template-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-search.min.js?v=87958022862029333331741240620"
  },
  "cart-template-section": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/bt-cart-page.min.js?v=134668128205204286031741240610"
  },
  "zoom": {
    "js": "//www.pinkyparadise.com/cdn/shop/t/42/assets/cloudzoom.js?v=14062328003065750181741240648"
  }
});

theme.dependTypeLibs = {
  "navigation-vertical": "navigation-section",
  "product": "product-global"
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _beforeCreateInstance: function(container, constructor, type) {
    if(!type) {
      type = $(container).attr('data-section-type');
    }
    if(theme.dependTypeLibs[type] == undefined) {
      BT.loadCssJsLib(type + '-section', function() {
        if(this.constructors[type] == undefined) {
          this.constructors[type] = constructor;
        }
        this._createInstance(container, constructor);
      }.bind(this));
    } else {
      BT.loadCssJsLib(theme.dependTypeLibs[type], function() {
        BT.loadCssJsLib(type + '-section', function() {
          if(this.constructors[type] == undefined) {
            this.constructors[type] = constructor;
          }
          this._createInstance(container, constructor);
        }.bind(this));
      }.bind(this));
    }
  },

  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._beforeCreateInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._beforeCreateInstance(container, constructor, type);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '$'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.sections = new theme.Sections();
BT.loadRequireCss();
BT.init();
function registerSections() {
  theme.sections.register('navigation', theme.DesktopNavigationSection);
  theme.sections.register('navigation-vertical', theme.VerticalNavigationSection);
  theme.sections.register('instagram', theme.InstagramSection);
  theme.sections.register('rich-banner-text', theme.RichBannerTextSection);
  theme.sections.register('layer-banner', theme.LayerBannerSection);
  theme.sections.register('simple-product-slider', theme.SimpleProductSliderSection);
  theme.sections.register('product', theme.ProductTemplateSection);
  theme.sections.register('product-tabs', theme.ProductTabsSection);
  theme.sections.register('product-columns', theme.ProductColumnsSection);
  theme.sections.register('map', theme.Maps);
  theme.sections.register('quotes', theme.QuotesSection);
  theme.sections.register('logo-bar', theme.LogoListSection);
  theme.sections.register('shop-this-look', theme.LookImageSection);
  theme.sections.register('logo-us', theme.LogoUsListSection);
  theme.sections.register('more-explore', theme.MoreExploreSection);
  theme.sections.register('trending-products', theme.TrendingProductsSection);
  theme.sections.register('single-deal', theme.SingleDealSection);
  theme.sections.register('about', theme.AboutSection);
  theme.sections.register('newsletter', theme.NewsletterSection);
  theme.sections.register('collection-filter', theme.CollectionFilterSection);
  theme.sections.register('footer', theme.FooterSection);
  theme.sections.register('collection-template', theme.CollectionTemplateSection);
  theme.sections.register('search-template', theme.SearchTemplateSection);
  theme.sections.register('cart-template', theme.CartTemplateSection);
}
if(BT.data.cacheWindowWidth <= BT.options.windowScreen.mobile) {
  $(document).ready(function() {
    registerSections();
  });
} else {
  registerSections();
}
/*  
if (window.self === window.top && 'serviceWorker' in navigator && theme.pwaEnable) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/a/bt-toolkit/js/sw.js',{ scope: "/" })
      .then(function (registration) {
        registration.update();
      })
      .catch((err) => console.log("Error", err));
  });
}*/

/*================ CHECKBOX SHOPPING CART ================*/
$(document).ready(function() {  
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
        $(this).submit();
      }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });
});


/*================ ADD SHAKY EFFECT TO PRE ORDER CHECKBOX ADD TO CART ================*/
$(document).ready(function() {
  
  var isProductPage = window.priceTier.product;
  
  
  if(isProductPage != null){
  
  var productType = window.priceTier.product.type;
  
  //console.log("productType",productType);
  
  if (productType == "Toric Circle Lenses" ){

    //console.log("productType", productType)
  
    $('body').on('click', '[name="add"]', function() {
      var inputChk = document.getElementById('this-item-only-available-for-pre-order-and-requires-45-60-days-production-time');
      if(!inputChk.checked){
        $('#labelPreOrderItem').addClass('shake-text');
        setTimeout(function() {
          $('#labelPreOrderItem').removeClass('shake-text');
        }, 2000);
      }
    });
    }else if(productType == "Planner"){
      $('body').on('click', '[name="add"]', function() {
      var inputCName = document.getElementById('customizeName').value;
      if(!inputCName){
        $('#customizeNameLabel').addClass('shake-text');
        setTimeout(function() {
          $('#customizeNameLabel').removeClass('shake-text');
        }, 2000);
      }
    });

    }else if(productType == "Colored Contacts & Circle Lenses" || productType == "Contact Lenses"){
/*
     $('body').on('click', '[name="add"]', function() {
      var inputOName = document.getElementById('oos').value;
      if(!inputOName){
        if (inputOName ==""){
        $('#oos').addClass('shake-text');
        setTimeout(function() {
          $('#oos').removeClass('shake-text');
        }, 2000);
        }
      }
    });
    */
    }
    
  }
  
   
  
});
